/** @format */

import Checkout from "../../pages/checkout/Checkout";

const CheckoutContainer = () => {
  return <Checkout />;
};

export default CheckoutContainer;
